import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { useParams } from 'src/routes/hooks';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import { LoanAgreementEditView } from 'src/sections/loan-agreement/view';

// Admin-only: the server rejects edits from anyone else regardless of
// UPDATE_LOAN_AGREEMENT.
export default function LoanEditPage() {
  const { id } = useParams();

  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title>Edit Loan Agreement</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <LoanAgreementEditView id={`${id}`} />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
